import { defineMessages, IntlFormatters } from "react-intl";

const taskTypeMessages = defineMessages({
    rhytSorting: {
        id: "taskTypes.rhytSorting",
    },
    barSorting: {
        id: "taskTypes.barSorting",
    },
    barSorting2: {
        id: "taskTypes.barSorting2",
    },
    barline: {
        id: "taskTypes.barline",
    },
    piano: {
        id: "taskTypes.piano",
    },
    melodyTable: {
        id: "taskTypes.melodyTable",
    },
    tonesetStaff: {
        id: "taskTypes.tonesetStaff",
    },
    flow: {
        id: "taskTypes.flow",
    },
    singing: {
        id: "taskTypes.singing",
    },
    rhytName: {
        id: "taskTypes.rhytName",
    },
    rhytKnock: {
        id: "taskTypes.rhytKnock",
    },
    subScore: {
        id: "taskTypes.subScore",
    },
    handSign: {
        id: "taskTypes.handSign",
    },
    rhytNotation: {
        id: "taskTypes.rhytNotation",
    },
    solfaName: {
        id: "taskTypes.solfaName",
    },
    intervals: {
        id: "taskTypes.intervals",
    },
    chords3: {
        id: "taskTypes.chords3",
    },
    embed: {
        id: "taskTypes.embed",
    },
});

export const taskTypes = (fm: IntlFormatters["formatMessage"]): {[taskType: string]: string} => {
    return {
        rhytSorting: fm(taskTypeMessages.rhytSorting),
        rhytKnock: fm(taskTypeMessages.rhytKnock),
        barSorting: fm(taskTypeMessages.barSorting),
        barSorting2: fm(taskTypeMessages.barSorting2),
        barline: fm(taskTypeMessages.barline),
        melodyTable: fm(taskTypeMessages.melodyTable),
        tonesetStaff: fm(taskTypeMessages.tonesetStaff),
        flow: fm(taskTypeMessages.flow),
        singing: fm(taskTypeMessages.singing),
        rhytName: fm(taskTypeMessages.rhytName),
        rhytNotation: fm(taskTypeMessages.rhytNotation),
        solfaName: fm(taskTypeMessages.solfaName),
        handSign: fm(taskTypeMessages.handSign),
        intervals: fm(taskTypeMessages.intervals),
        chords3: fm(taskTypeMessages.chords3),
        piano: fm(taskTypeMessages.piano),
        embed: fm(taskTypeMessages.embed),
        subScore: fm(taskTypeMessages.subScore),
    };
};

const planTypeMessages = defineMessages({
    written: {
        id: "planTypes.written",
    },
    folk: {
        id: "planTypes.folk",
    },
    exercise: {
        id: "planTypes.exercise",
    },
});

export const planTypes = (fm: IntlFormatters["formatMessage"]) => {
    return [
        { value: "written", label: fm(planTypeMessages.written) },
        { value: "folk", label: fm(planTypeMessages.folk) },
        { value: "exercise", label: fm(planTypeMessages.exercise) },
    ];
};

const exerciseTypeMessages = defineMessages({
    rhythm: {
        id: "exerciseTypes.rhythm",
    },
    melody: {
        id: "exerciseTypes.melody",
    },
    theory: {
        id: "exerciseTypes.theory",
    },
    other: {
        id: "exerciseTypes.other",
    },
});

export const exerciseTypes = (fm: IntlFormatters["formatMessage"]) => {
    return [
        { value: "rhythm", label: fm(exerciseTypeMessages.rhythm) },
        { value: "melody", label: fm(exerciseTypeMessages.melody) },
        { value: "theory", label: fm(exerciseTypeMessages.theory) },
        { value: "other", label: fm(exerciseTypeMessages.other) },
    ];
};
